module.exports = __webpack_public_path__ + "img/IMG_2493_L_Wood_MockedUp.a89cf22c.jpg";